import { useLocation } from "@reach/router";

/**
 * Current pathname, re-rendering on navigation.
 *
 * Lives outside `newui/` for the same reason as `RfxTabLink` / `useRfxNavigate`:
 * `newui/` bans a direct `@reach/router` import, but the nav menu still has to
 * know where it is in order to highlight the active entry.
 */
export const useRfxPathname = (): string => useLocation().pathname;
